import { useMutation } from "@tanstack/react-query";
import { UnknownRights } from "src/pages/Admin/UnknownRights/Type";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

async function mapUnknownRightRequest({ id, isin, security }: UnknownRights) {
	return await apiClient
		.put(API.COMMAND.ADMIN.UNKOWN_RIGHT(id), {
			mainSecurity: security?.id,
			isin
		})
		.then((res) => res.data);
}

export function useMapUnknownRight() {
	return useMutation({
		mutationFn: (sec: UnknownRights) => mapUnknownRightRequest(sec)
	});
}
